// PostCard.js
import React from "react";
import "./PostCard.css"; // optional if you use custom styles

function PostCard({ post }) {
  return (
    <div className="post-card">
      <h4>{post.post_content}</h4>
      {post.image_url && (
        <img src={post.image_url} alt="Post" style={{ maxWidth: "100%" }} />
      )}
      {post.video_url && (
        <video controls style={{ maxWidth: "100%" }}>
          <source src={post.video_url} type="video/mp4" />
        </video>
      )}
    </div>
  );
}

export default PostCard;
